var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Articolo',{staticClass:"pa-5",staticStyle:{"border-radius":"0px"},attrs:{"back_as_landing_page":true,"rotta_back":'/home/electrical'}})
}
var staticRenderFns = []

export { render, staticRenderFns }